// extracted by mini-css-extract-plugin
export default {"layout":"PScChtNB7RorAn0EACBjYQ==","content":"AcMmoFXBhO72xRCCkFQZ1w=="};